import { useState } from "react";
import DataTable from "./dashboard/common/data-table/data-table";

const header = [
    {
        name : "Name",
        key  : "key1"
    },
    {
        name : "Name",
        key  : "key2"
    },
]

const data = new Array(45).fill(0).map((item,i) => ({
    key1 : `key1 ${i} `,
    key2 : `key2 ${i}`   
}))



const Test = () => {

    const [selectedRows, setSelectedRows] = useState([]);
    const [search, setSearch] = useState("");

    return ( 
        <div className="p-5">
            {
                selectedRows.length
            }
            <input className="form-input" type="text" value={search} onChange={(e) => setSearch(e.target.value)} />
            <div className="card p-3">
                <DataTable 
                    header={header} 
                    rawData={data} 
                    paginate={true} 
                    selectable 
                    search={search}
                    setSelectedRows={setSelectedRows}
                />
            </div>
        </div> 
    );
}
 
export default Test;